import { Box, Text } from '@factorialco/deprecated-design-system'
import { Icon } from '@factorialco/factorial-one-react'
import { Person } from '@factorialco/factorial-one-react/icons/app'
import { Moment } from 'moment'

import { observer } from 'mobx-react'

import { useCalculateSummaryUnassignedShifts } from 'modules/shift_management/hooks/useCalculateSummaryUnassignedShifts'
import { useUnassignedShifts } from 'modules/shift_management/hooks/useUnassignedShifts'
import UnassignedShifts from 'modules/shift_management/store/internal/collections/UnassignedShifts'

interface CellProps {
  date: Moment
}

const CoverageShiftsSummary = ({ date }: CellProps) => {
  const [unassignedShifts] = useUnassignedShifts()

  const unassignedShiftsCollection = new UnassignedShifts(unassignedShifts)
  const unassignedShiftsByDate = unassignedShiftsCollection.filterByDate(date)

  const { totalCounters, totalTime } = useCalculateSummaryUnassignedShifts({
    unassignedShifts: unassignedShiftsByDate,
  })

  return (
    <Box
      flexDirection="row"
      alignItems="center"
      gap="s8"
      width="full"
      height="s16"
      padding="s4"
      border={{
        right: {
          width: 's1',
          style: 'solid',
          color: 'grey300',
        },
      }}
      background="grey000White"
    >
      <Box flexDirection="row" alignItems="center" width="full" justifyContent="flexStart" gap="s1">
        <Icon icon={Person} size="sm" />
        <Text size="50" weight="bold">
          {totalCounters}
        </Text>
      </Box>
      <Box flexDirection="row" alignItems="center" width="full" justifyContent="flexEnd">
        <Text size="50" weight="bold">
          {totalTime}
        </Text>
      </Box>
    </Box>
  )
}

export default observer(CoverageShiftsSummary)
